module.exports = __webpack_public_path__ + "static/media/EXP_Shield@3x.0997c128.png";